import apiKeys from './apiKeys';

export class LogService {
    apiKey;
    isDebug;
    isTest;
    identifixOrange;
    defaultConsole;

    constructor() {
        this.isDebug = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test';
        this.isTest = process.env.NODE_ENV === 'test';
        this.identifixOrange = 'color: #f4a442;';
        this.defaultConsole = 'color: #000000;'
        this.apiBaseUrl = '/api/v1/';
        this.jsonContentType = 'application/json; charset=utf-8';

        this.getLogKey();
    }

    logTrace = (message) => {
        this.log('TRACE', message);
    }

    logDebug = (message) => {
        this.log('DEBUG', message);
    }

    logInformation = (message) => {
        this.log('INFORMATION', message);
    }

    logWarning = (message) => {
        this.log('WARNING', message);
    }

    logError = (message) => {
        this.log('ERROR', message);
    }

    logCritical = (message) => {
        this.log('CRITICAL', message);
    }

    log = (logLevel, message) => {
        if (this.isDebug) {
            this.logToConsole(`%c${logLevel}: %c${message}`, this.identifixOrange, this.defaultConsole);
        } else {
            this.logToService(logLevel, message);
        }
    }

    logToConsole = (message, ...optionalParams) => {
        console.log(message, ...optionalParams);
    }

    logToService = (logLevel, message) => {
        fetch(apiKeys.API_LOG, {
            method: apiKeys.POST,
            headers: {
                'Content-Type': apiKeys.JSON_CONTENT_TYPE,
                'Identifix-Log-Api-Key': this.apiKey
            },
            body: JSON.stringify({
                logLevel: logLevel,
                message: message
            })
        }).catch(err => {
            this.logToConsole(err);
        });
    }

    async getLogKey() {
        if (this.apiKey) {
            return;
        }

        const apiKey = sessionStorage.getItem(apiKeys.LOG_API_KEY);
        if (apiKey) {
            this.apiKey = JSON.parse(apiKey);
            return;
        }
        
        const url = `${apiKeys.API_KEYS}?api-version=1.0`;
        // We want to ensure that apiKey is obtained before the user starts using the application.
        // "await" force "fetch" to run synchronously.
        // https://dev.to/johnpaulada/synchronous-fetch-with-asyncawait
        const response = await fetch(url, {
            method: apiKeys.GET,
        }).then(res => {
            return res.ok ? res.json() : Promise.reject(new Error('Failed to get log api key.'));
        }).catch(err => {
            this.logToConsole(err);
        });
        if (response && response.logConfiguration) {
            const apiKey = response.logConfiguration.key;
            sessionStorage.setItem(apiKeys.LOG_API_KEY, JSON.stringify(apiKey));
            this.apiKey = apiKey;
        }
    }
}

export default LogService;


// WEBPACK FOOTER //
// ./src/services/logService.js